import { z } from 'zod';
/** Image fidelity is an owner setting; changing it must also select a new persistent cache key. */
export const WebsiteImagesSchema = z.object({
    webp_quality: z.number().int().min(1).max(100),
    avif_quality: z.number().int().min(1).max(100),
    preserve_full_size_webp: z.boolean(),
}).strict();
export const websiteImagesDefaults = { webp_quality: 90, avif_quality: 80, preserve_full_size_webp: true };
//# sourceMappingURL=website-images.js.map